import _get from 'lodash/get';

export const getTemplate = (template, data) => {
  // Check if the template is a string or a function
  template = typeof template === 'function' ? template() : template;
  if (['string', 'number'].indexOf(typeof template) === -1)
    throw new Error('Please provide a valid template');

  // If no data, return template as-is
  if (!data) return template;

  // Replace our curly braces with data
  template = template.replace(/\{\{([^}]+)\}\}/g, match => {
    // Remove the wrapping curly braces
    match = match.slice(2, -2);

    // Get the value
    const val = _get(data, match);

    // Replace
    if (!val) return `{{${match}}}`;
    return val;
  });

  return template;
};

export const htmlToElements = html =>
  document.createRange().createContextualFragment(html);
